import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandShortcut,
} from "@/components/ui/command";
import {
  LayoutDashboard, Users, Car, FileText, FileSignature, CreditCard, ShoppingCart,
  Package as PackageIcon, Archive, Wrench, Zap, Droplet, Sofa, Flame, Blinds,
  ClipboardCheck, ShieldCheck, Truck, LifeBuoy, BarChart3, Settings as SettingsIcon,
  HelpCircle, UserCog,
} from "lucide-react";

const NAV_ITEMS = [
  { group: "Modüller", icon: LayoutDashboard, label: "Kontrol Paneli", path: "/", kw: "dashboard ana ozet" },
  { group: "Modüller", icon: Users, label: "Müşteriler", path: "/customers", kw: "customer musteri" },
  { group: "Modüller", icon: Car, label: "Araçlar", path: "/vehicles", kw: "vehicle arac karavan" },
  { group: "Modüller", icon: FileText, label: "Teklifler", path: "/quotations", kw: "quotation teklif" },
  { group: "Modüller", icon: FileSignature, label: "Sözleşmeler", path: "/contracts", kw: "contract sozlesme" },
  { group: "Modüller", icon: CreditCard, label: "Ödemeler", path: "/payments", kw: "payment odeme" },
  { group: "Modüller", icon: ShoppingCart, label: "Satın Alma", path: "/purchasing", kw: "purchasing satin alma jotform" },
  { group: "Modüller", icon: PackageIcon, label: "Paketler", path: "/packages", kw: "package paket" },
  { group: "Modüller", icon: Archive, label: "Stok", path: "/inventory", kw: "inventory stok depo" },
  { group: "Modüller", icon: Wrench, label: "Ekipman", path: "/equipment", kw: "equipment ekipman" },
  { group: "Modüller", icon: Truck, label: "Tedarikçiler", path: "/suppliers", kw: "supplier tedarikci" },
  { group: "Üretim", icon: LayoutDashboard, label: "Üretim Kanban", path: "/production", kw: "production uretim kanban" },
  { group: "Üretim", icon: Zap, label: "Elektrik Bölümü", path: "/electrical", kw: "electrical elektrik" },
  { group: "Üretim", icon: Droplet, label: "Su Bölümü", path: "/water", kw: "water su" },
  { group: "Üretim", icon: Sofa, label: "Mobilya Bölümü", path: "/furniture", kw: "furniture mobilya" },
  { group: "Üretim", icon: Flame, label: "Gaz Bölümü", path: "/gas", kw: "gas gaz" },
  { group: "Üretim", icon: Blinds, label: "Pencere & Çatı", path: "/windows", kw: "window pencere cati" },
  { group: "Üretim", icon: ClipboardCheck, label: "TSE / Ön Kontrol", path: "/tse", kw: "tse muayene" },
  { group: "Üretim", icon: ShieldCheck, label: "Kalite Kontrol", path: "/qc", kw: "qc kalite kontrol" },
  { group: "Servis", icon: Truck, label: "Teslimatlar", path: "/deliveries", kw: "delivery teslimat" },
  { group: "Servis", icon: LifeBuoy, label: "Servis Kayıtları", path: "/service", kw: "service garanti" },
  { group: "Sistem", icon: BarChart3, label: "Raporlar", path: "/reports", kw: "reports rapor" },
  { group: "Sistem", icon: SettingsIcon, label: "İşletme Ayarları", path: "/settings", kw: "settings ayar" },
  { group: "Sistem", icon: HelpCircle, label: "Yardım", path: "/help", kw: "help yardim" },
  { group: "Sistem", icon: UserCog, label: "Kullanıcılar", path: "/users", kw: "users kullanici" },
];

export default function CommandPalette() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const go = (path) => { setOpen(false); navigate(path); };

  // Group items by group name preserving order
  const grouped = NAV_ITEMS.reduce((acc, it) => {
    acc[it.group] = acc[it.group] || [];
    acc[it.group].push(it);
    return acc;
  }, {});

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Modül ara... (örn. teklif, elektrik, stok)" data-testid="cmd-palette-input" />
      <CommandList>
        <CommandEmpty>Sonuç bulunamadı</CommandEmpty>
        {Object.entries(grouped).map(([group, items]) => (
          <CommandGroup key={group} heading={group}>
            {items.map((it) => {
              const Icon = it.icon;
              return (
                <CommandItem key={it.path} value={`${it.label} ${it.kw}`} onSelect={() => go(it.path)}>
                  <Icon className="w-4 h-4 mr-2" />
                  {it.label}
                </CommandItem>
              );
            })}
          </CommandGroup>
        ))}
        <CommandGroup heading="Kısayollar">
          <CommandItem value="cmd k" disabled>
            Menüyü aç
            <CommandShortcut>⌘K / Ctrl+K</CommandShortcut>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
